export default "__VITE_ASSET__ca37ea6a__"